import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {
  ArcElement,
  Chart,
  ChartConfiguration,
  DoughnutController,
  Legend,
  Plugin,
  Title,
  Tooltip
} from 'chart.js';
import { hasChanged } from 'src/app/utils/change-utils';

@Component({
  selector: 'app-battery-doughnut',
  templateUrl: './battery-doughnut.component.html',
  styleUrls: ['./battery-doughnut.component.scss']
})
export class BatteryDoughnutComponent
  implements AfterViewInit, OnChanges, OnDestroy
{
  @Input() chartId: string;
  @Input() batteryLevel: number;
  @Input() batteryRange: number;

  @ViewChild('chart') chartRef: ElementRef<HTMLCanvasElement>;

  chart: Chart<'doughnut'>;
  ctx: HTMLCanvasElement;

  constructor() {
    Chart.register(DoughnutController, ArcElement, Title, Legend, Tooltip);
  }

  ngAfterViewInit() {
    if (
      this.batteryLevel !== undefined &&
      this.batteryRange !== undefined &&
      this.chartId
    ) {
      this.ctx = this.chartRef.nativeElement;
      if (this.ctx) {
        this.createChart(this.ctx);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      !changes.batteryLevel?.firstChange &&
      !changes.batteryRange?.firstChange &&
      !changes.chartId?.firstChange &&
      hasChanged([changes.batteryLevel, changes.batteryRange, changes.chartId])
    ) {
      this.ctx = this.chartRef.nativeElement;
      if (this.ctx) {
        this.createChart(this.ctx);
      }
    }
  }

  ngOnDestroy() {
    if (this.chart !== undefined) {
      this.chart.destroy();
    }
  }

  createChart(ctx: HTMLCanvasElement) {
    if (this.chart !== undefined) {
      this.chart.destroy();
    }

    const middleTextPlugin = (range: number): Plugin => ({
      id: 'middletext',
      beforeDatasetsDraw(chart, args, pluginOptions) {
        const { ctx, data } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        ctx.font = 'bold 1.5rem Plus Jakarta Sans';
        ctx.fillStyle = '#002987';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(`${Number(data.datasets[0].data[0])}%`, xCoor, yCoor - 10);
        ctx.font = 'normal 1rem Plus Jakarta Sans';
        ctx.fillText(
          range !== null ? `${range?.toFixed(0)} km` : 'Ukjent rekkevidde',
          xCoor,
          yCoor + 10
        );
      }
    });
    const config: ChartConfiguration<'doughnut'> = {
      type: 'doughnut',
      data: {
        labels: ['Batteristatus'],
        datasets: [
          {
            data: [this.batteryLevel, 100 - this.batteryLevel],
            label: 'Batteristatus',
            backgroundColor: ['#26b41b', '#d6f2ff']
          }
        ]
      },
      options: {
        cutout: '75%',
        animation: false,
        plugins: {
          title: {
            display: false,
            text: 'Batteristatus',
            font: {
              family: 'Poppins',
              size: 20,
              weight: 'normal'
            },
            color: '#002987'
          },
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          }
        },
        // Disable all events
        events: []
      },
      //@ts-ignore
      plugins: [middleTextPlugin(this.batteryRange)]
    };
    this.chart = new Chart<'doughnut'>(ctx, config);
  }
}
